export function canUserReplyToEmail(
  endUserEmail: string,
  senderEmail: string | undefined,
  recipient: string | undefined,
) {
  // If the end user is not a participant in the original email thread, they should not be able to reply
  // to avoid errors from Nylas
  return [recipient?.toLowerCase(), senderEmail?.toLowerCase()].includes(endUserEmail.toLowerCase());
}
